<template>
	<section v-loading="loading" class="public-form">
		<div class="public-form-content">
			<div class="logo">
				<router-link :to="{ name: 'login' }">
					<img :src="brand.logo.default" :alt="brand.companyName" :title="brand.companyName" />
				</router-link>
			</div>

			<h2 v-if="title" class="mb-2">{{title}}</h2>

			<slot>
				<p>Coming soon!</p>
			</slot>

		</div>

		<existing-account-footer />

	</section>
</template>


<script>
    import { ExistingAccountFooter } from '@/components/public';
    import AppConfig from '@/config';


	export default {
		name: 'public-form-layout',
		components: {
			ExistingAccountFooter
		},
		props: {
			title: {
				type: String,
				required: true,
				default: null,
				description: `The layout's page title`
			},
			loading: {
				type: Boolean,
				default: false,
				description: `The layout's loading state`
			}
        },
        data() {
            return {
                brand: AppConfig.brand
            };
        }
	};
</script>


<style lang="scss">
@import '~@/assets/styles/references';


.public-form { width: 100%; display: flex; flex-direction: column; }

.public-form-content { padding: gx(3); }


@include media-breakpoint-down(sm) {
	.public-form {
		justify-content: flex-start;
	}
	.container {
		width: 100%;
	}
}

</style>
